"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wktToGeoJson = void 0;
var Wkt = require('wicket');
/*
    Callback function for the MapPlugin.
    Uses wicket to parse WktLiterals to GeoJson and leaflet objects
*/
var wktToGeoJson = function (literal) {
    // split on whitespaces and filter out multiple subsequent whitespaces
    var stringParts = literal.split(' ').filter(function (subStr) { return subStr !== " "; });
    // look for either Point or Polygon string
    var featureType = stringParts.find(function (string) {
        return string.includes('Polygon') || string.includes('POLYLINE') || string.includes('POINT') || string.includes('Point') || string.includes('Polyline') || string.includes('POLYGON');
    });
    if (!featureType)
        throw Error("The parsing function couldn't find substring \"Polygon\" or \"Point\" in wktLiteral: ".concat(literal));
    var ind = stringParts.findIndex(function (prt) { return prt.includes(featureType); });
    var wkt = stringParts.slice(ind, stringParts.length).join(' ');
    var wktObj = new Wkt.Wkt();
    wktObj.read(wkt);
    //wktObj.toObject();
    return wktObj.toJson();
};
exports.wktToGeoJson = wktToGeoJson;
